import { bffServiceInstance } from "@/plugins/api_service/services";

const prefix = "/management/billing-addresses";

export default {
  search: (query) => bffServiceInstance.get(`${prefix}`, query),
  create: () => bffServiceInstance.get(`${prefix}/create`, {}),
  store: (data) => bffServiceInstance.post(`${prefix}`, {}, data),
  show: (id) => bffServiceInstance.get(`${prefix}/${id}`),
  update: (id, body) => bffServiceInstance.put(`${prefix}/${id}`, {}, body),
  remove: (id) => bffServiceInstance.delete(`${prefix}/${id}`),
  detailByCorporateCode: (code) =>
    bffServiceInstance.get(`${prefix}/get-list-by-corporate-code/${code}`),
  detailByAccountCode: (code) =>
    bffServiceInstance.get(`${prefix}/get-list-by-account-code/${code}`),
  setDefault: (id) =>
    bffServiceInstance.put(`${prefix}/set-default-billing-address/${id}`),
  getPaymentMethod: (query) =>
    bffServiceInstance.get(
      `management/facilities-payment-agencies/get-select-list`,
      query
    ),
};
